import PropTypes from 'prop-types';
import { Button } from 'components/common';
import { notification } from 'antd';
import qs from 'query-string';

export const downloadGuidRegex =
  'download=(?:\\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\\}{0,1})';
const extractContent = html => {
  let htmlToRender = html;
  let guid;
  let hrefQueryParams = {};
  const downloadGuidMatch = html.match(downloadGuidRegex);
  const hrefMatch = html.match(/<a\s+href=["']([^"']+)["']/i);
  if (downloadGuidMatch) {
    const downloadGuid = downloadGuidMatch[0];
    guid = downloadGuid.replace('download=', '');
    htmlToRender = htmlToRender.replace(/<a href=.+/i, '');
  }
  if (hrefMatch) {
    const hrefUrl = hrefMatch[1];
    const queryIndex = hrefUrl?.indexOf('?');
    if (queryIndex >= 0) {
      hrefQueryParams = qs.parse(hrefUrl.substring(queryIndex + 1));
    }
  }

  return [htmlToRender, guid, hrefQueryParams?.source];
};

const DownloadNotification = ({ html, replace, notificationKey }) => {
  const [htmlToRender, guid, source] = extractContent(html);
  const handleDownload = () => {
    const params = new URLSearchParams({ download: guid });
    if (source) params.set('source', source);
    replace({ pathname: window.location.pathname, search: params.toString() });
    notification.close(notificationKey);
  };

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: htmlToRender }} />
      {guid && (
        <>
          <Button type='link' onClick={handleDownload} style={{ padding: 0 }}>
            Click here
          </Button>{' '}
          to download the report now.
        </>
      )}
    </div>
  );
};

DownloadNotification.propTypes = {
  html: PropTypes.string.isRequired,
  replace: PropTypes.func.isRequired,
};

export default DownloadNotification;
